export const getPlanName = (plan?: string) => {
  switch (plan) {
    default: {
      return plan ?? '';
    }
  }
};

export const getPlanPeriod = (TRANSLATION_TEXT: any, period?: string) => {
  if (period === '1year') {
    return TRANSLATION_TEXT.billed_annually;
  }
  if (period === '1month') {
    return TRANSLATION_TEXT.billed_monthly;
  }
  return TRANSLATION_TEXT.billed_annually;
};
